// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2023 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import BaseModel from '@glittr/frontend-core/src/plugins/servicelayer/serviceTypes/baseModel';
import IntegrationCallStateOverviewResourceViewModel from '../../../../viewModel/resource/IntegrationCallStateOverviewResourceViewModel';
import ResourceLinkViewModel from '../../../../viewModel/resource/ResourceLinkViewModel';
import IntegrationCallStateOverviewResourceListResultViewModel from '../../../../viewModel/resource/IntegrationCallStateOverviewResourceListResultViewModel';
import IntegrationCallStateOverviewResourceListResultDTO from '../../dto/resource/IntegrationCallStateOverviewResourceListResultDTO';

export default abstract class IntegrationCallStateOverviewResourceListResultModel extends BaseModel<IntegrationCallStateOverviewResourceListResultDTO> {
  /**
  */
  get items() { return this.getArrayModels(() => this.dto.items, IntegrationCallStateOverviewResourceViewModel)!; }
  set items(value) { this.setArrayModels(() => this.dto.items, value); }
  /**
  */
  get links() { return this.getArrayModels(() => this.dto.links, ResourceLinkViewModel)!; }
  set links(value) { this.setArrayModels(() => this.dto.links, value); }

  protected transformFromQuery(queries: Record<string, string>): void {
    const qs = {} as Record<string, string>;
    Object.keys(queries).forEach((key) => { qs[key.toLowerCase()] = queries[key]; });
    let value: any;
  }
}
